import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "vue-content-placeholders-heading" }
const _hoisted_2 = {
  key: 0,
  class: "vue-content-placeholders-heading__img"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.img)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "vue-content-placeholders-heading__content" }, [
      _createElementVNode("div", { class: "vue-content-placeholders-heading__title" }),
      _createElementVNode("div", { class: "vue-content-placeholders-heading__subtitle" })
    ], -1))
  ]))
}